import React, { useState, useRef } from 'react';
import { withRouter } from 'react-router';
import gsap from 'gsap';
import { event } from '@minerva-analytics/pantheon';
import SvgNaviconAbout from '../../assets/navicon_about';
import SvgNaviconHome from '../../assets/navicon_home';
import SvgNaviconRedbubble from '../../assets/navicon_redbubble';
import SvgNaviconCompatibility from '../../assets/navicon_compatibility';
import SvgNaviconArticles from '../../assets/navicon_articles.svg';
import NavFooter from '../NavFooter';
import { NavRouteItem } from './NavRouteItem';

import NavHoroscopeAccordion from '../NavHoroscopeAccordion';
import {
  NavButton,
  NavMenu,
  NavOverlay,
  NavClose,
  NavList,
  NavIcon,
  NavItem,
  NavButtonText,
  NavButtonWrapper,
  ExternalNavLink,
  SVGIcon,
} from './Nav.styles';

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const overlayRef = useRef(null);

  const toggleNav = () => {
    const refReady = Boolean(menuRef.current && overlayRef.current);
    if (!refReady) {
      return;
    }

    if (open) {
      setOpen(!open);
      gsap.to(menuRef.current, { xPercent: -100, autoAlpha: 0 });
      gsap.to(overlayRef.current, { autoAlpha: 0 });
    } else {
      setOpen(!open);
      gsap.fromTo(
        menuRef.current,
        { autoAlpha: 1, xPercent: -100 },
        { autoAlpha: 1, xPercent: 0 },
      );
      gsap.to(overlayRef.current, { autoAlpha: 0.4 });
    }
  };

  return (
    <>
      <NavButtonWrapper
        onClick={() => {
          event([`click`, `open-nav`]);
          toggleNav();
        }}
      >
        <NavButton />
        <NavButtonText>
          Menu
        </NavButtonText>
      </NavButtonWrapper>
      <NavMenu ref={menuRef}>
        <div>
          <NavClose
            onClick={() => {
              event([`click`, `close-nav`]);
              toggleNav();
            }}
          />
          <NavList>
            <NavRouteItem
              route="/"
              text="home"
              toggleNav={toggleNav}
            >
              <NavIcon>
                <SvgNaviconHome alt="Home icon on the navigation panel" />
              </NavIcon>
              Home
            </NavRouteItem>
            <NavHoroscopeAccordion toggleNav={toggleNav} />
            <NavRouteItem
              route="/compatibility-calculator"
              text="Compatibility Calculator"
              toggleNav={toggleNav}
            >
              <NavIcon>
                <SvgNaviconCompatibility alt="Compatibility icon on the navigation panel" />
              </NavIcon>
              Compatibility Calculator
            </NavRouteItem>
            <NavRouteItem
              route="/articles"
              text="articles"
              toggleNav={toggleNav}
            >
              <NavIcon>
                <SVGIcon src={SvgNaviconArticles} alt="Articles icon on the navigation panel" />
              </NavIcon>
              Articles
            </NavRouteItem>
            <NavRouteItem
              route="/about"
              text="about"
              toggleNav={toggleNav}
            >
              <NavIcon>
                <SvgNaviconAbout alt="About icon on the navigation panel" />
              </NavIcon>
              About
            </NavRouteItem>
            <NavItem onClick={() => event([`click`, `nav-item`, `nav-redbubble`])}>
              <ExternalNavLink href="https://www.redbubble.com/people/minerva1/shop?asc=u" target="_blank">
                <NavIcon><SvgNaviconRedbubble alt="Redbubble icon on the navigation panel" /></NavIcon>
                Shop Starguide RedBubble
              </ExternalNavLink>
            </NavItem>
          </NavList>
        </div>
        <div>
          <NavFooter toggleNav={toggleNav} />
        </div>
      </NavMenu>
      <NavOverlay ref={overlayRef} onClick={toggleNav} />
    </>
  );
};

export default withRouter(Nav);
